/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { CursorManager } from '../../../../core/navigation';
import type { TivoPayloadAction } from '../../../../core/tivo/tivo-redux-wrapper';
import { ratigLimitSetFocusedPositionAction } from './setratinglimits.actions';
import {
    RATING_LIMITS_SET_HIGHLIGHT_POSITION,
    RATING_LIMITS_SET_IS_GHOST_MODE_ENABLED,
    RATING_LIMITS_SET_OPTION_LIMIT_LIST,
    RATING_LIMITS_SET_SELECTED_OPTION_LIST,
    RATING_LIMITS_SET_VERTICAL_LIMIT,
    RATING_LIMITS_SET_VERTICAL_POSITION,
} from './setratinglimits.types';

interface ISetRatingLimits {
    verticalLimit: number;
    verticalPosition: number;
    selectedOptionList: number[];
    optionLimitList: number[];
    isGhostModeEnabled: boolean;
}

const initialState: ISetRatingLimits = {
    verticalLimit: 0,
    verticalPosition: 0,
    selectedOptionList: [],
    optionLimitList: [],
    isGhostModeEnabled: false,
};

const setRatingLimitsReducer = (
    state = initialState,
    { type, payload } = <TivoPayloadAction<ISetRatingLimits>>{},
) => {
    switch (type) {
        case RATING_LIMITS_SET_VERTICAL_LIMIT:
            return {
                ...state,
                verticalLimit: payload.verticalLimit,
            };
        case RATING_LIMITS_SET_VERTICAL_POSITION:
            return {
                ...state,
                verticalPosition: payload.verticalPosition,
            };
        case RATING_LIMITS_SET_SELECTED_OPTION_LIST:
            return {
                ...state,
                selectedOptionList: payload.selectedOptionList,
            };
        case RATING_LIMITS_SET_OPTION_LIMIT_LIST:
            return {
                ...state,
                optionLimitList: payload.optionLimitList,
            };
        case RATING_LIMITS_SET_IS_GHOST_MODE_ENABLED:
            return {
                ...state,
                isGhostModeEnabled: payload.isGhostModeEnabled,
            };
        case RATING_LIMITS_SET_HIGHLIGHT_POSITION:
            return {
                ...state,
                verticalPosition: payload.verticalPosition,
                isGhostModeEnabled: payload.isGhostModeEnabled,
            };

        default:
            return state;
    }
};

export const onCursorStateChangeSetRatingLimitsOperations =
    () => (dispatch: Function, getState: Function) => {
        const { verticalPosition } = getState().setRatingLimits;
        if (CursorManager.isCursorAppeared()) {
            dispatch(ratigLimitSetFocusedPositionAction(verticalPosition, true));
        } else {
            dispatch(ratigLimitSetFocusedPositionAction(verticalPosition, false));
        }
    };

export default setRatingLimitsReducer;
